
// Define action constants
module.exports = {
  RECEIVE_DATA : 0,
  DELETE_ANNOUNCEMENT: 1,
  ADD_ANNOUNCEMENT: 2,
  EDIT_ANNOUNCEMENT: 3// Loads our mock data
};


/** WEBPACK FOOTER **
 ** ./src/constants/AnnouncementConstants.js
 **/